// Add your custom JS here.

jQuery(document).ready(function ($) {

    if (typeof $.fn.flexslider !== 'undefined') {
        $('#carousel').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            itemWidth: 210,
            itemMargin: 5,
            asNavFor: '#slider'
        });
    
        // Initialize Flexslider
        $('#slider').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            sync: "#carousel",
            itemWidth: 782, // Adjust the width to match your main image width
            itemMargin: 0,   // Set itemMargin to 0 to remove any extra margin
            minItems: 1,     // Ensure only one slide is visible
            maxItems: 1      // Ensure only one slide is visible
        });
    }


    // Ajax request when clicking on a experience filter option
    $('#experience-filter a').on('click', function (e) {
        e.preventDefault();

        let productList = document.getElementById('product-list');

        var destination_id = productList.getAttribute('data-filter-id');

        // Remove active class from all filter options
        $('#experience-filter a').removeClass('active');

        // Add active class to the clicked filter option
        $(this).addClass('active');

        // Get the selected filter value
        var filterValue = $(this).data('filter');

        // Ajax request to retrieve filtered products
        $.ajax({
            type: 'POST',
            url: ajaxurl, // WordPress AJAX handler
            data: {
                action: 'filter_products_destination',
                filter: filterValue,
                destination_id: destination_id
            },
            success: function (response) {
                // Update the product list with the filtered results
                $('#product-list').html(response);
            }
        });
    });


     // Ajax request when clicking on a destination filter option
     $('#destination-filter a').on('click', function (e) {
        
        e.preventDefault();

        let productList = document.getElementById('product-list');

        var experience_id = productList.getAttribute('data-filter-id');

        // Remove active class from all filter options
        $('#destination-filter a').removeClass('active');

        // Add active class to the clicked filter option
        $(this).addClass('active');

        // Get the selected filter value
        var filterValue = $(this).data('filter');

        // Ajax request to retrieve filtered products
        $.ajax({
            type: 'POST',
            url: ajaxurl, // WordPress AJAX handler
            data: {
                action: 'filter_products_experience',
                filter: filterValue,
                experience_id: experience_id
            },
            success: function (response) {
                // Update the product list with the filtered results
                $('#product-list').html(response);
            }
        });
    });

    // Function to trigger the filtering
    function triggerFilter(selectedTag) {
        $('#blog-filter a').removeClass('active');
        
        // Find the filter link that matches the tag and add the active class
        $('#blog-filter a').each(function () {
            if ($(this).data('filter') === selectedTag) {
                $(this).addClass('active');
            }
        });

        // Make the AJAX request to filter posts by the tag
        $.ajax({
            type: 'POST',
            url: ajaxurl, // Replace with your AJAX URL
            data: {
                action: 'filter_blog_posts',
                filter: selectedTag
            },
            success: function (response) {
                // Update the post list with the filtered results
                $('#post-list').html(response);
            }
        });
    }

    // Function to update the query string in the URL without reloading the page
    function updateQueryStringParameter(key, value) {
        let url = new URL(window.location.href);
        url.searchParams.set(key, value);
        history.pushState(null, null, url.toString());
    }

    // Check if there's a tag in the URL and trigger the filter
    const urlParams = new URLSearchParams(window.location.search);
    const selectedTag = urlParams.get('tag');
    
    if (selectedTag) {
        triggerFilter(selectedTag);
    }

    // Handle clicks on the filter links (tags)
    $('#blog-filter a, .tag-link').on('click', function (e) {
        e.preventDefault();
        
        let filterValue = $(this).data('filter');

        // Update the URL query string without reloading the page
        updateQueryStringParameter('tag', filterValue);

        // Trigger the filter with the selected tag
        triggerFilter(filterValue);
    });

    
    // jQuery code to show third-level navigation items by default
  
    // Add custom class to third-level dropdown menu items
    $('.navbar-nav .dropdown-menu .dropdown-menu').addClass('submenu');

    // Check if the product is in the "campervans" category
    if ($('.product_cat-campervans').length) {
        // Change button text to "Get a Quote"
        $('.btn.btn-outline-primary').text('Get a Quote');
        // Change button link to /getquote
        $('.btn.btn-outline-primary').attr('href', '/getquote');

        // Prevent default action when the button is clicked
        $('.btn.btn-outline-primary').on('click', function(event) {
            event.preventDefault(); // Prevent the default action
            window.location.href = $(this).attr('href'); // Redirect to the "get a quote" page
        });
    }

     // Check if the current page is a WooCommerce single product page
     if ($('body').hasClass('single-product')) {
        // Function to adjust the height of the gallery container
        function adjustGalleryHeight() {
            var summaryHeight = $('.summary').outerHeight();
            $('.woocommerce-product-gallery').css('height', summaryHeight + 'px');
        }

        // Call the function initially
        adjustGalleryHeight();

        // Check viewport width before attaching MutationObserver
        if ($(window).width() >= 768) { // Adjust the threshold as needed
            //console.log("james");
            // Listen for changes to the height of the summary div
            // MutationObserver is used to detect changes to the DOM
            var observer = new MutationObserver(function(mutationsList, observer) {
                // Call the adjustGalleryHeight function whenever the summary div changes
                adjustGalleryHeight();
            });

            // Select the target node (summary div) for observing changes
            var targetNode = document.querySelector('.summary');

            // Options for the observer (which mutations to observe)
            var config = { attributes: true, childList: true, subtree: true };

            // Start observing the target node for changes
            observer.observe(targetNode, config);
        }

        // Listen for window resize to re-adjust the gallery height
        $(window).on('resize', function() {
            if ($(window).width() >= 768) {
                adjustGalleryHeight();
            } else {
                // Reset the height of the gallery container to auto for mobile viewports
                $('.woocommerce-product-gallery').css('height', 'auto');
            }
        });
    }
});


document.addEventListener("DOMContentLoaded", function() {

    document.addEventListener('scroll', function () {
        console.log('Scroll event detected!');
    });

    document.querySelectorAll('.dropdown-menu').forEach(function(element) {
        element.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    })

    if (window.innerWidth < 992) {

        document.querySelectorAll('.dropdown-menu a').forEach(function(element) {
            element.addEventListener('click', function(e) {

                let nextEl = this.nextElementSibling;
                if (nextEl && nextEl.classList.contains('submenu')) {
                    e.preventDefault();
                    if (nextEl.style.display == 'block') {
                        nextEl.style.display = 'none';
                    } else {
                        nextEl.style.display = 'block';
                    }

                }
            });
        })
    }

    //gtranslate add notranslate to particular classes

    let elements = document.querySelectorAll('.woocommerce-Price-amount ');

    // Add the custom class to each of them
    elements.forEach(function(element) {
    element.classList.add('notranslate');
    });

});




    


